// src/Components/Wizard/copyText.js

const getOptionLabel = (question, selectedValue) => {
  if (!selectedValue) return "未選択";

  const matchedOption = question.options?.find((option) => {
    if (typeof option === "string") {
      return option === selectedValue;
    }

    return option.value === selectedValue;
  });

  if (!matchedOption) return selectedValue;

  return typeof matchedOption === "string" ? matchedOption : matchedOption.label;
};

export const generateSingleProductText = ({ product, questions, selections = {} }) => {
  const getSelectedText = (key) => {
    const question = questions.find((q) => q.key === key);
    if (!question) return selections[key] ?? "未選択";

    return getOptionLabel(question, selections[key]);
  };

  return `【相談したい商品】
商品名：${product?.productName ?? ""}
型番：${product?.modelNumber ?? ""}

【診断内容】
設置場所：${getSelectedText("mountType")}
建物の種類：${getSelectedText("buildingType")}
インターネット状況：${getSelectedText("connectivity")}
録画方法：${getSelectedText("recordingMethod")}
撮影範囲：${getSelectedText("lensType")}
防水防塵：${getSelectedText("waterproofDustproof")}
画質：${getSelectedText("resolution")}
暗所撮影：${getSelectedText("lowLightPerformance")}
AI機能：${getSelectedText("aiFeatures")}

【補足】
詳しい設置場所や台数などは、相談しながら決めたいです。`;
};
export const generateCopyText = ({ products, questions, selections = {} }) => {
  return (products ?? [])
    .map((product) =>
      generateSingleProductText({
        product,
        questions,
        selections,
      })
    )
    .join("\n\n");
};

export const selectionTextFrom = ({ questions, selectedOptions }) => {
  return questions
    .map((q) => {
      const value = selectedOptions?.[q.key];
      return `${q.question}：${getOptionLabel(q, value)}`;
    })
    .join("\n");
};

export const buildLineSelectionUrl = ({ selectionText }) => {
  return `https://line.me/R/oaMessage/@camarago/?${encodeURIComponent(
    selectionText + "\n上記の条件でカメラを探しています。"
  )}`;
};
